import classNames from "classnames/bind";
import { Stack, Typography } from "@mui/material";
import Tooltip from "../../../../common/components/atoms/Tooltip";
import styles from "../CleanroomCreateInstall.module.scss";

const cx = classNames.bind(styles);

export const IdHubOptionsWithTag = (column) => (
    <Tooltip
        arrow={true}
        title="Column is made available by joining from mapping table"
        placement="right"
        className={cx("IdHubOptions_Tooltip")}
    >
        <Stack flexDirection={"row"} gap={1} alignItems="center">
            <label className={cx("IdHubOptions_ColumnName")}>{column}</label>
            <Typography
                className={cx("IdHubOptions_Tag")}
                variant="typography15"
            >
                ID Hub
            </Typography>
        </Stack>
    </Tooltip>
);
